// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__0_Dq5","dottedUnderline":"Text_dottedUnderline__44r9I"};